import { Organization } from "myfitworld-model";

export const useShouldShowPremium = ({ option, isSuperAdmin, isMfwOnMfwPlatform, currentOrganization }: {
  option: boolean
  isSuperAdmin: boolean,
  isMfwOnMfwPlatform: boolean,
  currentOrganization: Organization | undefined,
}): boolean => {

  // Before:
  //organizationId === process.env.REACT_APP_MFW_ORGANIZATION_ID || // isMfwOnMfwPlatform
  //  (currentOrganization && currentOrganization.isPremiumSwitchEnabled)) &&  ???? zasto ???
  //            !isClient &&
  //            options.showPremium && 

  const orgPermission: boolean = (currentOrganization && currentOrganization?.isPremiumSwitchEnabled) || isMfwOnMfwPlatform;
  const userPermission: boolean = isSuperAdmin;
  const result:boolean = option && orgPermission && userPermission;

  return result;
};